export const QuoteData = {};
export const propertyTypeOptions = [
  { value: 'House', label: 'House' },
  { value: 'Apartment', label: 'Apartment' },
  { value: 'Townhouse', label: 'Townhouse' },
  { value: 'Condo', label: 'Condo' },
  { value: 'Duplex', label: 'Duplex' },
  { value: 'Triplex', label: 'Triplex' },
  { value: 'Fourplex', label: 'Fourplex' },
  { value: 'Mobile Home', label: 'Mobile Home' },
  { value: 'Manufactured Home', label: 'Manufactured Home' },
  { value: 'Other', label: 'Other' }
];
export const purposeOptions = [
  { value: 'Purchase', label: 'Purchase' },
  { value: 'Refinance', label: 'Refinance' },
  { value: 'Cash Out', label: 'Cash Out' },
  { value: 'Home Equity', label: 'Home Equity' },
  { value: 'Other', label: 'Other' }
];

export const statusOptions = [
  { value: 'Single', label: 'Single' },
  { value: 'Married', label: 'Married' }
];
export const propertyStatusOptions = [
  { value: 'commercial', label: 'Commercial' },
  { value: 'residential', label: 'Residential' }
];

export const furnitureOptions = [
  { value: 'Furnished', label: 'Furnished' },
  { value: 'Unfurnished', label: 'Unfurnished' },
  { value: 'Partially Furnished', label: 'Partially Furnished' }
];

export const interiorAmenitiesOptions = [
  { value: 'Air Conditioning', label: 'Air Conditioning' },
  { value: 'Balcony', label: 'Balcony' },
  { value: 'Cable Ready', label: 'Cable Ready' },
  { value: 'Ceiling Fan(s)', label: 'Ceiling Fan(s)' },
  { value: 'Dishwasher', label: 'Dishwasher' },
  { value: 'Fireplace', label: 'Fireplace' },
  { value: 'Furnished', label: 'Furnished' },
  { value: 'Garbage Disposal', label: 'Garbage Disposal' },
  { value: 'Hardwood Floors', label: 'Hardwood Floors' },
  { value: 'Island Kitchen', label: 'Island Kitchen' },
  { value: 'Microwave', label: 'Microwave' }
];

export const exteriorAmenitiesOptions = [
  { value: 'Barbeque Area', label: 'Barbeque Area' },
  { value: 'Business Center', label: 'Business Center' },
  { value: 'Clubhouse', label: 'Clubhouse' },
  { value: 'Controlled Access', label: 'Controlled Access' },
  { value: 'Covered Parking', label: 'Covered Parking' },
  { value: 'Elevator', label: 'Elevator' },
  { value: 'Fitness Center', label: 'Fitness Center' },
  { value: 'Gated Access', label: 'Gated Access' }
];

export const eventTypeOptions = [
  { value: 'auction', label: 'Auction' },
  { value: 'trip', label: 'Trip' }
];
export const LanguageOptions = [
  { value: 'english', label: 'English' },
  { value: 'arabic', label: 'Arabic' },
  { value: 'spanish', label: 'Spanish' }
];
export const NoOfUnitsOptions = [
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5+' }
];

export const residentialLangObj = {
  ar: 'سكني',
  de: 'Wohnung',
  en: 'Residential',
  fa: 'مسکونی',
  fr: 'Résidentiel',
  ru: 'Жилой',
  tr: 'Konut'
};

export const propertyLangObj = {
  ar: 'عقارات',
  de: 'Immobilien',
  en: 'Properties',
  fa: 'املاک',
  fr: 'Propriétés',
  ru: 'Недвижимость',
  tr: 'Mülkler'
};

export const inTurkeyLangObj = {
  ar: 'تركيا',
  de: 'Türkei',
  en: 'Turkey',
  fa: 'ترکیه',
  fr: 'Turquie',
  ru: 'Турция',
  tr: 'Türkiye'
};

export const commercialLangObj = {
  en: 'Commercial',
  fa: 'مسکونی',
  tr: 'Konut',
  ar: 'سكني',
  ru: 'Жилой',
  de: 'Wohnung',
  fr: 'Résidentiel'
};

export const buyLangObj = {
  en: 'sale',
  fa: 'برای فروش',
  tr: 'satılık',
  ar: 'للبيع',
  ru: 'на продажу',
  de: 'Verkauf',
  fr: 'vente'
};

export const rentLangObj = {
  en: 'rent',
  fa: 'اجاره',
  tr: 'kiralamak',
  ar: 'استئجار',
  ru: 'арендовать',
  de: 'mieten',
  fr: 'louer'
};
